module.exports = __webpack_public_path__ + "img/fedramp.4b83f6fa.png";